// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import Colors from 'components/styles/colors'
import { mediaMin } from 'frontend_core/dist/styles/media'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'
import FormSectionTitle from 'components/molecules/FormSectionTitle'
import HeadlineReservation from 'components/molecules/HeadlineReservation'
import Button from 'components/atoms/Button'
import FloatBottom from 'components/molecules/FloatBottom'
import ReservationChangeRequestBlock, {
  type PropTypes as ReservationChangeRequestBlockProps,
} from 'components/molecules/ReservationChangeRequestBlock'
import ReservationGetPointBlock, {
  type PropTypes as ReservationGetPointBlockProps,
} from 'components/molecules/ReservationGetPointBlock'
import ReservationAdditionalFeeBlock, {
  type PropTypes as ReservationAdditionalFeeBlockProps,
} from 'components/molecules/ReservationAdditionalFeeBlock'

const PayNoticeText = styled.div`
  text-align: center;
  color: ${Colors.red};
  font-weight: bold;
  font-size: ${fontSize.small_3}px;
  line-height: 1.4;
  margin-top: ${spacing.medium_2}px;
  ${mediaMin.phone`
    margin-top: ${spacing.large}px;
  `};
`
const PayNoticeTextBr = styled.br`
  ${mediaMin.phone`
    display: none;
  `};
`
const ButtonItem = styled.div`
  width: calc((100% - 8px) / 2);
  display: inline-block;

  &:not(:first-child) {
    margin-left: ${spacing.small_2}px;
  }

  ${mediaMin.phone`
    width: 160px;
    font-size: ${fontSize.small_3}px;
  `};
`
const TotalFeeWrap = styled.div`
  ${mediaMin.phone`
    margin-top: ${spacing.medium}px;
    padding-top: ${spacing.medium}px;
    border-top: 1px dashed ${Colors.grayE};
  `};
`

type PropTypes = {
  reservationChangeRequestBlockProps: ReservationChangeRequestBlockProps,
  reservationGetPointBlockProps: ReservationGetPointBlockProps,
  reservationAdditionalFeeBlockProps: ReservationAdditionalFeeBlockProps,
  onClickBackToMessage: Function,
  onClickDenial: Function,
  onClickApprove: Function,
}

export default function ReservationChangeHostPage(props: PropTypes) {
  return (
    <React.Fragment>
      <HeadlineReservation
        title={i18n.t(
          'page.dashboard.reservation.reservationChangeFromHost.title',
        )}
        href="#"
        linkText={i18n.t('page.dashboard.reservation.backToMessage')}
        onClick={props.onClickBackToMessage}
      >
        {i18n.t('page.dashboard.reservation.reservationChangeFromHost.desc')}
      </HeadlineReservation>
      <ReservationChangeRequestBlock
        {...props.reservationChangeRequestBlockProps}
      />
      <ReservationGetPointBlock {...props.reservationGetPointBlockProps} />
      <ReservationAdditionalFeeBlock
        {...props.reservationAdditionalFeeBlockProps}
      />
      <FloatBottom textAlign="right" hasSidebar>
        <ButtonItem>
          <Button
            buttonType="medium"
            colorType="gray"
            tag="button"
            fullWidthSp
            fontSizePc={14}
            onClick={props.onClickDenial}
          >
            {i18n.t('page.shared.denial')}
          </Button>
        </ButtonItem>
        <ButtonItem>
          <Button
            buttonType="medium"
            colorType="blue"
            tag="button"
            fullWidthSp
            fontSizePc={14}
            onClick={props.onClickApprove}
          >
            {i18n.t('page.shared.approval')}
          </Button>
        </ButtonItem>
      </FloatBottom>
      <ReservationAdditionalFeeBlock
        {...props.reservationAdditionalPaidyProps}
      />
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/organisms/ReservationChangeHostForm/index.jsx